export const ALIGNMENT_OPTIONS = [
  { value: 'hero', label: 'Super-héros' },
  { value: 'villain', label: 'Super-vilains' },
  { value: 'antihero', label: 'Anti-héros' },
  { value: 'vigilante', label: 'Vigilante' },
  { value: 'neutral', label: 'Neutre' },
  { value: 'other', label: 'Autre' },
];

export const SCOPE_OPTIONS = [
  { value: 'galaxy', label: 'Galaxie' },
  { value: 'international', label: 'International' },
  { value: 'national', label: 'National' },
  { value: 'regional', label: 'Régional' },
  { value: 'local', label: 'Local' },
];

const ALIGNMENT_META = {
  hero: { label: 'Super-héros', tone: 'hero' },
  villain: { label: 'Super-vilain', tone: 'villain' },
  antihero: { label: 'Anti-héros', tone: 'antihero' },
  vigilante: { label: 'Vigilante', tone: 'vigilante' },
  neutral: { label: 'Neutre', tone: 'neutral' },
  other: { label: 'Autre', tone: 'other' },
};

const SCOPE_META = {
  galaxy: { label: 'Galaxie', icon: 'globe' },
  international: { label: 'International', icon: 'globe' },
  national: { label: 'National', icon: 'flag' },
  regional: { label: 'Régional', icon: 'map' },
  local: { label: 'Local', icon: 'pin' },
};

export const getAlignmentMeta = (rawAlignment) => {
  const key = String(rawAlignment || '').toLowerCase().trim();
  if (ALIGNMENT_META[key]) {
    return ALIGNMENT_META[key];
  }

  return {
    label: rawAlignment || 'Non défini',
    tone: 'other',
  };
};

export const getScopeMeta = (rawScope) => {
  const key = String(rawScope || '').toLowerCase().trim();
  if (SCOPE_META[key]) {
    return SCOPE_META[key];
  }

  return {
    label: rawScope || 'Non définie',
    icon: 'map',
  };
};

export const createDefaultSections = () => [
  { title: 'Description', content: '' },
];

export const normalizeSections = (sections) => {
  if (!Array.isArray(sections) || sections.length === 0) {
    return createDefaultSections();
  }

  const normalized = sections.map((section, index) => ({
    id: section.id ?? null,
    title: section.title || (index === 0 ? 'Description' : ''),
    content: section.content || '',
  }));

  if (normalized[0]) {
    normalized[0].title = 'Description';
  }

  return normalized;
};
